import { Autocomplete, Box, Button, TextField, createFilterOptions } from '@mui/material'

import type { DropdownOption, DropdownOptionsByField } from '../../dropdown/types/dropdown.types'

type DropdownFieldProps = {
  label: string
  fieldName: string
  value: string
  onChange: (value: string) => void
  options: DropdownOptionsByField
  required: boolean
  error?: string
  helperText?: string
  disabled?: boolean
  onRequestOption?: (fieldName: string, label: string) => void
}

const dropdownFilter = createFilterOptions<DropdownOption>({
  matchFrom: 'any',
  stringify: option => `${option.display_value} ${option.internal_value}`,
  trim: true,
})

export function DropdownField({
  label,
  fieldName,
  value,
  onChange,
  options,
  required,
  error,
  helperText,
  disabled = false,
  onRequestOption,
}: DropdownFieldProps) {
  const fieldOptions = options[fieldName] || []
  const selectedOption = fieldOptions.find(option => option.internal_value === value) || null

  return (
    <Box>
      <Autocomplete
        options={fieldOptions}
        value={selectedOption}
        onChange={(_, option) => onChange(option?.internal_value || '')}
        getOptionLabel={option => option?.display_value || ''}
        isOptionEqualToValue={(option, selected) => option.internal_value === selected.internal_value}
        filterOptions={dropdownFilter}
        disabled={disabled}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            required={required}
            error={Boolean(error)}
            helperText={error || helperText}
          />
        )}
        clearOnEscape
        fullWidth
      />
      {!disabled && onRequestOption && (
        <Box display="flex" justifyContent="flex-end">
          <Button
            size="small"
            sx={{
              px: 0,
              minWidth: 'auto',
              color: 'text.secondary',
              fontSize: '0.75rem',
              fontWeight: 400,
              textTransform: 'none',
            }}
            onClick={() => onRequestOption(fieldName, label)}
          >
            Request Option
          </Button>
        </Box>
      )}
    </Box>
  )
}
